export const PublicRoutePath = {
  root: "/",
  login: "/login",
  home: "/home",
  inputTest: "/test/input",
  buttonTest: "/test/button",
  footerNavTest: "/test/footer-nav",
} as const;
